import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { config } from '../config';

export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const apiUrl = config.apiUrl;
  const imageUrl = config.imageUrl;
  
  // সমস্ত স্টেট
  const [categories, setCategories] = useState([]);
  const [contactInfo, setContactInfo] = useState({});
  const [logo, setLogo] = useState('');
  const [headerMenus, setHeaderMenus] = useState([]);
  const [footerMenus, setFooterMenus] = useState([]);
  const [socialLinks, setSocials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchProducts, setSearchProducts] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [bonus, setBonus] = useState({});
  const [coinPackages, setCoinPackages] = useState([]);
  const [users, setUsers] = useState([]);

  // Retry helper function
const retryRequest = async (fn, retries = 3, delay = 2000) => {
    try {
      return await fn();
    } catch (error) {
      if (retries > 0 && error.response?.status === 429) {
        console.warn(`⏳ Rate limit hit. Retrying in ${delay}ms...`);
        await new Promise(res => setTimeout(res, delay));
        return retryRequest(fn, retries - 1, delay * 2); // exponential backoff
      } else {
        throw error;
      }
    }
  };


  // সমস্ত ডেটা ফেচ করার ফাংশন
  const fetchHeaderData = useCallback(async () => {
    setLoading(true);
    try {
      const [categoriesRes, contactRes,socialRes, menusRes, logosRes, bonusCoin,coinPackage,users] = await Promise.all([
        retryRequest(() => axios.get(`${apiUrl}/category`)),
        retryRequest(() => axios.get(`${apiUrl}/contactinfos`)),
        retryRequest(() => axios.get(`${apiUrl}/sociallinks`)),
        retryRequest(() => axios.get(`${apiUrl}/menus`)),
        retryRequest(() => axios.get(`${apiUrl}/websitelogos`)),
        retryRequest(() => axios.get(`${apiUrl}/bonuscoins`)),
        retryRequest(() => axios.get(`${apiUrl}/coinpackages`)),
        retryRequest(() => axios.get(`${apiUrl}/users`)),

      ]);

      // ক্যাটাগরি সেট
      setCategories(categoriesRes.data.categories.sort((a, b) => a.order - b.order));
      
      // কন্টাক্ট ইনফো সেট
      setContactInfo(contactRes.data[0] || {});
      
      // মেনু সেট
      const allMenus = menusRes.data;
      setHeaderMenus(allMenus.filter(menu => menu.menu_type === 'header').sort((a, b) => a.order - b.order));
      setFooterMenus(allMenus.filter(menu => menu.menu_type === 'footer').sort((a, b) => a.order - b.order));
      
      // লোগো সেট
      setLogo(logosRes.data[0]);

        // সোশ্যাল লিঙ্কস সেট
      const filteredSocials = socialRes.data.filter(social => social.status === 1);
      setSocials(filteredSocials);

      setBonus (bonusCoin.data[0])
      setCoinPackages(coinPackage.data)
      setUsers(users.data)

    } catch (err) {
      setError(err.message || "An error occurred");
      console.error("Header data fetch error:", err);
      
      // রিট্রাই লজিক
      if (err.response?.status === 429) {
        await new Promise(resolve => setTimeout(resolve, 2000));
        await fetchHeaderData();
      }
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  // সার্চ ফাংশন
  const handleSearch = async (searchText) => {
    try {
      const response = await axios.get(`${apiUrl}/products`);
      const filteredProducts = response.data.filter(product =>
        product.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setSearchProducts(filteredProducts);
      setShowResults(true);
    } catch (error) {
      console.error("Search error:", error);
      setSearchProducts([]);
      setShowResults(true);
    }
  };

  // প্রাথমিক ডেটা লোড
  useEffect(() => {
    fetchHeaderData();
  }, [fetchHeaderData]);

  return (
    <HeaderContext.Provider
      value={{
        users,
        bonus,
        coinPackages,
        categories,
        contactInfo,
        logo,
        socialLinks,
        headerMenus,
        footerMenus,
        loading,
        error,
        imageUrl,
        searchProducts,
        showResults,
        handleSearch,
        setShowResults,
        refetchData: fetchHeaderData
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};